import React from "react";
import ScrollRevealText from "../Comman/ScrollRevealText";

export default function Frequently() {
  return (
    <>
      <div className="  pt-80  pb-150 z-index-5">
        <div className="container ">
          <div className="row justify-content-center">
            <div className="col-xxl-12 col-xl-12 ">
              <div className="tp-about-2-title-box tp-btn-trigger tp-btn-bounce  text-start text-xl-center">
                <ScrollRevealText text="Claim Your Land. Secure Your Future" />
              </div>
            </div>
          </div>

          <div className="row align-items-center">
            <div className="col-xxl-6 col-xl-4 col-lg-4">
              <div className="text-center text-lg-start">
                <div className="img-box-r">
                  <img
                    src="assets/img/one/claim_your_lands_secure_your_future.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div className="col-xxl-6 col-xl-8 col-lg-8">
              <div className="tp-service-2-accordion-box">
                <div className="accordion" id="accordionExample">
                  <div className="accordion-items">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-buttons collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        <span>
                          <img src="assets/img/one/scenic_luxury.png" alt="" />
                        </span>
                        Scenic Luxury
                        <span className="accordion-icon" />
                      </button>
                    </h2>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <p>
                          Surrounded by breathtaking landscapes and pristine
                          waters.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-items">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-buttons collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        <span>
                          <img
                            src="assets/img/one/blockchain_community_hub.png"
                            alt=""
                          />
                        </span>
                        Blockchain Community Hub
                        <span className="accordion-icon" />
                      </button>
                    </h2>
                    <div
                      id="collapseTwo"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <p>
                          A visionary real-estate project fostering
                          collaboration and innovation.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-items">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-buttons collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        <span>
                          <img
                            src="assets/img/one/global_prestige.png"
                            alt=""
                          />
                        </span>
                        Global Prestige
                        <span className="accordion-icon" />
                      </button>
                    </h2>
                    <div
                      id="collapseThree"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <p>
                          Become part of an exclusive network of
                          forward-thinking investors and NFT holders.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
